import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../components/HomeViewPc.vue'
import HomeViewMb from '@/components/HomeViewMb.vue'
import RoleInfoViewMb from '@/components/mobileView/RoleInfoViewMb.vue'
import PayViewMb from '@/components/mobileView/PayViewMb.vue'
import UserInfoViewMb from '@/components/mobileView/UserInfoViewMb.vue'
import RecordSheetViewMb from '@/components/mobileView/RecordSheetViewMb.vue'
import RemarkViewMb from '@/components/mobileView/RemarkViewMb.vue'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { showNav: false }
    },{
      path: '/m',
      name: 'homem',
      component: HomeViewMb,
      meta: { showNav: false }
    },{
      path: '/role_info_m',
      name: 'roleinfom',
      component: RoleInfoViewMb,
      meta: { showNav: true }
    },{
      path: '/trade_m',
      name: 'tradem',
      component: PayViewMb,
      meta: { showNav: true }
    },{
      path: '/user_info_m',
      name: 'userinfom',
      component: UserInfoViewMb,
      meta: { showNav: true }
    },{
      path: '/sheet_m',
      name: 'recordsheet',
      component: RecordSheetViewMb,
      meta: { showNav: true }
    },{
      path: '/remark_m',
      name: 'remarkview',
      component: RemarkViewMb,
      meta: { showNav: true }
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    localStorage.setItem('fromPath', from.fullPath)
  }
  next()
})

export default router
